import React, { Fragment } from 'react'

function Modal(props) {
    const selectProduct = props.seleccion

    return (
        <Fragment>

            <div className="modal fade" id="clickModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">{selectProduct.nombre}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md">
                                    {
                                        selectProduct.imagengrande === undefined?"":
                                        <img src={"https://servicios.campus.pe/" + selectProduct.imagengrande} alt={selectProduct.nombre} className="img-fluid" />
                                    }
                                   
                                </div>
                                <div className="col-md">
                                    <table className='table'>
                                        <tbody>
                                            <tr><th>Detalle</th><td>{selectProduct.detalle}</td></tr>
                                            <tr><th>Precio</th><td>S/.
                                                {

                                                    selectProduct.preciorebajado === "0" ?
                                                        parseFloat(selectProduct.precio).toFixed(2) :
                                                        parseFloat(selectProduct.preciorebajado).toFixed(2)

                                                }
                                            </td></tr>
                                            <tr><th>Categoria</th><td>{selectProduct.categoria}</td></tr>
                                            <tr><th>Proveedor</th><td>{selectProduct.proveedor}</td></tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary text-capitalize" data-bs-dismiss="modal">cerrar</button>
                            <button type="button" className="btn btn-primary text-capitalize"><i className="fa-solid fa-cart-shopping"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Modal